import { render, staticRenderFns } from "./SingleMeasureQuestion.vue?vue&type=template&id=52f4193b"
import script from "./SingleMeasureQuestion.vue?vue&type=script&lang=js"
export * from "./SingleMeasureQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports